import React from 'react';
import PropTypes from 'prop-types';
import { VIEW_MODES } from '../constants';
import { componentText } from '../utils/i18n_utils';

const LeaderboardV2Header = ({ leagueId, leagueName, viewMode, type, children }) => (
  <header id={leagueId} className={`lbv2__leaderboard-header ${type}`}>
    <h1>{type === "lbv2__aggregate-rounds" ? componentText('mobile_modal.select_round', 'Select Round') : leagueName}</h1>
    {viewMode === VIEW_MODES.MOBILE && <p></p>}
    {children}
  </header>
);

LeaderboardV2Header.propTypes = {
  leagueId: PropTypes.string,
  leagueName: PropTypes.string,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)),
  type: PropTypes.string,
  children: PropTypes.node,
};

export default LeaderboardV2Header;
